// Story 24.4 — first: capture the boot entry's history key before any page
// (and its PageHeader) loads. See src/lib/ui/initialEntry.ts.
import './lib/ui/initialEntry';
// Story 25.1 — the theme store: applies the resolved theme once at boot and
// installs the OS colour-scheme listener (dev-gated until 25.8).
import './lib/theme';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Self-hosted fonts (CSP-compliant)
import '@fontsource/dm-sans/400.css';
import '@fontsource/dm-sans/500.css';
import '@fontsource/dm-sans/600.css';
import '@fontsource/dm-sans/400-italic.css';
import '@fontsource/dm-sans/500-italic.css';
import '@fontsource/newsreader/400.css';
import '@fontsource/newsreader/500.css';
import '@fontsource/newsreader/600.css';
import '@fontsource/newsreader/400-italic.css';
import '@fontsource/newsreader/500-italic.css';

import './index.css';
import App from './App.tsx';
import ErrorBoundary from './components/ErrorBoundary.tsx';
import { reportWebVitals } from './lib/utils/reportWebVitals';
import { startKeyboardTracking } from './lib/ui/keyboard';

// Story 24.7b — the ONE visualViewport listener (`--kb-inset` + the
// keyboard-open signal), started once before the first render.
startKeyboardTracking();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);

// Report Web Vitals for performance monitoring
reportWebVitals();
